import React, {FC} from 'react';
import ThCustom from "@ui/tableCustom/view/ui/thCustom/ThCustom";
import TrCustom from "@ui/tableCustom/view/ui/trCustom/TrCustom";
import {ITableFeaturesRowProps} from "@ui/tableCustom/types/table";
import {sx} from './sx'
import {IDeviceActivityTransform} from "@containers/device/containers/deviceActivity/types";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import CurrentValue from "@containers/device/containers/deviceActivity/listDeviceActivity/item/CurrentValue";

interface IProps extends ITableFeaturesRowProps<IDeviceActivityTransform> {
    columns: IColumnItem<IDeviceActivityTransform>[]
}

const Item: FC<IProps> = ({
                              content,
                              exportFeaturesProps,
                              columns
                          }) => {

    const list = columns?.map((column, index) => {
        return (
            <ThCustom
                key={column.id}
                sx={column.id === 'displayName' ? sx.sticky : sx.base}
            >
                <CurrentValue
                    content={content}
                    column={column}
                    exportFeaturesProps={exportFeaturesProps}
                />
            </ThCustom>
        )
    })

    return (
        <TrCustom>
            {list}
        </TrCustom>
    );
};

export default Item;